Vue.component("result-popup", {
	template: `
	<div class="search-result search-dialog">
		<div class="search-dialog-backdrop" @click="hideResults"></div>
		<div class="search-dialog-inner">
			<div class="search-dialog-header">
				<h2 class="hd">銭湯検索</h2>
				<button type="button" class="btn btn-s pull-left" @click="hideResults">戻る</button>
				<button type="button" class="btn btn-s pull-right" @click="toggleResultMode" v-show="store.resultMode === 'map'">リスト</button>
				<button type="button" class="btn btn-s pull-right" @click="toggleResultMode" v-show="store.resultMode === 'list'">地図</button>
			</div>
			<div class="search-dialog-content">
				<div class="pane" :class="{visible: store.resultMode === 'map'}">
					<map-view :results="store.results" :map-loaded="store.mapLoaded" :position="store.position">
					</map-view>
				</div>
				<div class="pane" :class="{visible: store.resultMode === 'list'}">
					<ul class="search-result-list">
						<li class="search-result-list-item" v-for="bath in store.results" @click="setShop(bath)">
							<div class="tx search-shop-detail-content">
								<h3 class="name">
									{{ bath.name }}
									<span class="fi fi-disabled" v-if="bath.is_perm_closed">閉店</span>
									<span class="fi fi-disabled" v-else-if="bath.is_closed">休業中</span>
								</h3>
								<p class="addr">{{ bath.city }}{{ bath.address }} {{ bath.address2 }}</p>
								<div class="features" v-if="!bath.is_closed && !bath.is_perm_closed">
									<ul class="feature-list">
										<li><span class="fi" aria-label="営業時間">営</span> {{ bath.open_time }}</li>
										<li><span class="fi" aria-label="休業日">休</span> {{ bath.closed }}</li>
										<li v-if="bath.num_parking > 0">
											<span class="fi" aria-label="駐車場">駐</span> {{ bath.num_parking }}&nbsp;台
											{{ bath.parking_desc }}
										</li>
										<li v-else><span class="fi" aria-label="駐車場">駐</span> なし</li>
									</ul>
								</div>
							</div>
							<div class="img">
								<img alt="" :src="'/uploads/raw/' + bath.image">
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="search-dialog-footer">
				<div class="cond">
					<strong>検索条件:</strong>
					<ul class="cond-list">
						<li v-if="cond.area">{{cond.area}}</li>
						<li v-if="cond.has_parking">駐車場</li>
						<template v-for="facility in store.facilities">
							<li v-if="cond[facility.name]">{{ facility.label }}</li>
						</template>
						<template v-for="feature in store.bathFeatures">
							<li v-if="cond[feature.name]">{{ feature.label }}</li>
						</template>
					</ul>
				</div>
				<button type="button" class="btn btn-s pull-right" @click="hideResults">変更</button>
			</div>
		</div>
	</div>
	`,

	props: {
		cond: Object
	},

	data() {
		return {
			store
		};
	},

	methods: {
		hideResults() {
			this.$emit("hideResults");
		},

		setShop(shop) {
			this.$emit("setShop", shop);
		},

		toggleResultMode() {
			this.$emit("toggleResultMode");
		},
	},
});
